import Vue from "vue";
import Router from "vue-router";
import Entity from "./views/entity";
import Virtual from "./views/virtual";
import Confirm from "./views/confirm";
import Success from "./views/success";
import Auth from "./views/auth";
import AuthApp from "./views/AuthApp";
import Inquire from "./views/inquire";
import InquireApp from "./views/InquireApp";
import CardDetailApp from "./views/CardDetailApp";
import BankList from "./views/BankList";
import Pay from "./views/pay";
import WxPay from "./views/wx-pay";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default new Router({
  mode: "history",
  // mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      //首页
      path: "/",
      name: "entity",
      component: Entity,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "选购产品-全球付",
        requireHeader: true,
        requireHeader2: true,
        requireFooter: true
      }
    },
    {
      //首页
      path: "/virtual",
      name: "virtual",
      component: Virtual,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "选购产品-全球付",
        requireHeader: true,
        requireHeader2: true,
        requireFooter: true
      }
    },
    {
      //首页
      path: "/confirm",
      name: "confirm",
      component: Confirm,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "信息产品-全球付",
        requireHeader: true,
        requireHeader2: true,
        requireFooter: true
      }
    },
    {
      //首页
      path: "/success",
      name: "success",
      component: Success,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "订单完成-全球付",
        requireHeader: true,
        requireHeader2: true,
        requireFooter: true
      }
    },
    {
      //首页
      path: "/auth",
      name: "auth",
      component: Auth,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "身份验证-全球付",
        requireHeader: true,
        requireHeader2: true,
        requireFooter: true
      }
    },
    {
      //首页
      path: "/inquire",
      name: "inquire",
      component: Inquire,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "卡详情-全球付",
        requireHeader: true,
        requireHeader2: true,
        requireFooter: true
      }
    },
    {
      //首页
      path: "/auth-app",
      name: "auth-app",
      component: AuthApp,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "身份验证-全球付",
        requireHeader: false,
        requireHeader2: false,
        requireFooter: false
      }
    },
    {
      //首页
      path: "/inquire-app",
      name: "inquire-app",
      component: InquireApp,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "卡详情-全球付",
        requireHeader: false,
        requireHeader2: false,
        requireFooter: false
      }
    },
    {
      //首页
      path: "/card-detail",
      name: "card-detail-app",
      component: CardDetailApp,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "卡详情-全球付",
        requireHeader: false,
        requireHeader2: false,
        requireFooter: false
      }
    },
    {
      //首页
      path: "/banklist",
      name: "bankList",
      component: BankList,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "立即支付-全球付",
        requireHeader: true,
        requireHeader2: true,
        requireFooter: true
      }
    },
    {
      path: "/wxPay",
      name: "wxPay",
      component: WxPay,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "立即支付-全球付",
        requireHeader: true,
        requireHeader2: true,
        requireFooter: true
      }
    },
    {
      path: "/aliPay",
      name: "aliPay",
      component: () => import("@/views/ali-pay"),
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "立即支付-全球付",
        requireHeader: true,
        requireHeader2: true,
        requireFooter: true
      }
    },
    {
      //首页
      path: "/pay",
      name: "pay",
      component: Pay,
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "立即支付-全球付",
        requireHeader: true,
        requireHeader2: true,
        requireFooter: true
      }
    },
    {
      path: "",
      name: "fastPayBind",
      component: () => import("@/views/fast-pay/components/Layout.vue"),
      meta: {
        keepAlive: false,
        requireLogin: false,
        title: "立即支付-全球付",
        requireHeader: true,
        requireHeader2: true,
        requireFooter: true
      },
      children: [
        {
          path: "fastRegister",
          component: () => import("@/views/fast-pay/register.vue"),
          meta: {
            keepAlive: false,
            requireLogin: false,
            title: "立即支付-全球付",
            requireHeader: true,
            requireHeader2: true,
            requireFooter: true
          }
        },
        {
          path: "fastPay",
          name: "fastPay",
          component: () => import("@/views/fast-pay/pay.vue"),
          meta: {
            keepAlive: false,
            requireLogin: false,
            title: "立即支付-全球付",
            requireHeader: true,
            requireHeader2: true,
            requireFooter: true
          }
        }
      ]
    },
    {
      path: "*",
      component: Entity
    }
  ]
});
